import React from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter" 
import { oneDark } from "react-syntax-highlighter/dist/cjs/styles/prism"

const KwikMarkdown = ({children}) => {
    const handleClick = (event) => {
        const link = event.target.closest?.('a')

        if (!link?.href) return

        event.preventDefault()
        event.stopPropagation()

        const newWindow = window.open(link.href, '_blank', 'noopener,noreferrer')

        if (newWindow) {
            newWindow.opener = null
        }
    }

    return (
        <div className='kwik_markdown' onClick={handleClick}>
            <ReactMarkdown
                remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
                components={{
                    a({ node, ...props }) {
                        return (
                            <a
                                {...props}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        )
                    },
                    code({ node, inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || "")
                        return !inline && match ? (
                            <SyntaxHighlighter
                                style={oneDark}
                                language={match[1]}
                                PreTag="div"
                                {...props}
                            >
                                {String(children).replace(/\n$/, "")}
                            </SyntaxHighlighter>
                        ) : (
                            <code className={className} {...props}>
                                {children}
                            </code>
                        )
                    }
                }}
            >
                {children}
            </ReactMarkdown>
        </div>
    )
}

export default KwikMarkdown
